import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    id: 'view.nav.items.search',
    defaultMessage: 'Search',
  },
  clearSearchValue: {
    id: 'ariaLabel.clearSearchValue',
    defaultMessage: 'Clear search value',
  },
});
